import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DevMainComponent } from './components/dev-main/dev-main.component';

const routes: Routes = [
    {
        path: 'main',
        component: DevMainComponent
    },
    {
        path: '',
        redirectTo: "main",
        pathMatch: "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DevRoutingModule {
}
